import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  FormHelperText,
} from "@mui/material";
import { toast } from "react-toastify";
function CategoryForm({ closeModal, fetchCategories, selectedCategory }) {
  const API_BASE_URL = process.env.REACT_APP_BASE_URL;
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Initialize form methods from react-hook-form
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting: formSubmitting },
    reset,
  } = useForm({
    defaultValues: selectedCategory || { category_name: "", status: "1" }, // Default values for new or editing category
  });

  // On form submit
  const onSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      const url = selectedCategory
        ? `${API_BASE_URL}/Menu_category/form/${selectedCategory.id}` // Update category if selectedCategory exists
        : `${API_BASE_URL}/Menu_category/form`; // Create new category

      const response = await axios.post(url, data); // Send the form data to the server
      if (response.data.status === "Success") {
        toast(
          selectedCategory
            ? "Category updated successfully!"
            : "Category added successfully!"
        );
        fetchCategories(); // Fetch the updated categories list
        closeModal(); // Close the modal after successful submission
        reset(); // Reset the form
      } else {
        setError(response.data.status_message || "Error saving category data.");
      }
    } catch (err) {
      setError("An error occurred while submitting the form.");
    } finally {
      setIsSubmitting(false); // Reset submitting state
    }
  };

  return (
    <div className="CategoryFormContainer">
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        {/* Category Name */}
        <TextField
          label="Category Name"
          variant="outlined"
          fullWidth
          margin="normal"
          size="small" // Adjust size to small
          {...register("category_name", {
            required: "This field is required.",
          })}
          error={!!errors.category_name}
          helperText={errors.category_name?.message}
        />

        {/* Status */}
        <FormControl
          fullWidth
          margin="normal"
          size="small"
          error={!!errors.status}
        >
          {" "}
          {/* Adjust size to small */}
          <InputLabel>Status</InputLabel>
          <Select
            {...register("status", {
              required: "This field is required.",
            })}
            label="Status"
            size="small" // Adjust size to small
          >
            <MenuItem value="1">Active</MenuItem>
            <MenuItem value="0">Inactive</MenuItem>
          </Select>
          {errors.status && (
            <FormHelperText>{errors.status.message}</FormHelperText>
          )}
        </FormControl>

        {/* Error message */}
        {error && <div className="error-message">{error}</div>}

        {/* Submit Button */}
        <div className="form-footer">
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            size="small" // Adjust size to small
            disabled={isSubmitting}
          >
            {isSubmitting ? <CircularProgress size={24} /> : "Save"}
          </Button>
        </div>
      </form>
    </div>
  );
}

export default CategoryForm;
